import { Component } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';
import { distinctUntilChanged, filter } from 'rxjs';
import { routes } from 'src/app/app-routing.module';
import { BreadcrumbService } from './breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';
import { PRIVATE_ROUTE_PATH } from 'src/app/system/core/private.routes';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.less'],
    standalone: false
})
export class BreadcrumbComponent {

  private routerMap = new Map<string, []>();
  public breadcrumbs!: Breadcrumb[];
  protected isVizModule: boolean = false;

  constructor(
    private srvTitle: Title,
    private translate: TranslateUtilityService,
    private router: Router,
    private service: BreadcrumbService) {

    // Build Router Map
    this.buildRouterMap();

    // Build Breadcrumb during the first load
    this.buildBreadcrumb();

    // Rebuild the Breadcrumb during navigation
    this.router.events.pipe(
      filter((event: Event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe(() => {
      this.isVizModule = this.router.url.includes('viz');
      this.buildBreadcrumb();
    })

    this.service.breadcrumbs$.subscribe(breadcrumbs => {
      this.buildBreadcrumb();
      this.breadcrumbs = this.breadcrumbs?.concat(breadcrumbs);
    })
  }

  // Read the static define Routing in the App Routing Moddule
  private buildRouterMap(): void {
    routes.forEach((route) => route.children?.forEach((value) => {
      if (value.path != null && value.data != null) {
        // Change the URL Path Variable to a constant
        let path = value.path.replace(/:.*$/, "URL_PATH_VARIABLE");
        this.routerMap.set(path, value.data as []);
      }
    })
  );
  }

  // Build the breadcrumb based on the current URL
  private buildBreadcrumb(): void {
    let url = this.router.url.replace(new RegExp(`^/${PRIVATE_ROUTE_PATH}(?=/|$)`), '');
    url = url.replace(/\?.*$/, "");
    url = url.replace(/^\//, "");

    let labels = this.routerMap.get(url);

    // If the labels is undefined, try to lookup using URL_PATH_VARIABLE
    if (labels == undefined) {
      url = url.replace(/\/.*/, "/URL_PATH_VARIABLE")
      labels = this.routerMap.get(url);
    }

    if (labels == undefined) {
      return;
    }

    let _self = this;
    this.breadcrumbs = labels.map((label: string) => {
      return {
        description: label,
        link: _self.lookupLink(label)
      }
    });

    // Update the Page Title
    let newTitle = this.breadcrumbs.map(b => this.translate.instant(b.description)).join(" / ");
    this.srvTitle.setTitle(newTitle);
  }

  // Link is not supported at this moment
  private lookupLink(label: string): string {
    return "";
  }

  protected needVizPrefix(breadcrumb: Breadcrumb) {
    return breadcrumb.description.includes('VIZ.SEND_MONEY') || breadcrumb.description.includes('VIZ.ALIAS');
  }
}


export interface Breadcrumb {
  link: string;
  description: string;
}

